<template>
    <div>
        <sms-balance/>

        <statistics/>

        <client/>
    </div>
</template>

<script>
    export default {
        components: {
            client: () => import('./widgets/client/Panels'),
            statistics: () => import('./widgets/statistics/Main'),
            smsBalance: () => import('./widgets/SmsBalance'),
        },


        metaInfo() {
            return {
                title: 'Дашборд',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    };
</script>
